import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { common_axios } from "../../../App";

export default function UserTableMain() {
  const [Status, setStatus] = useState("allUser");

  const [value, setValue] = useState("");
  const [dataSource, setDataSource] = useState();
  const [tableFilter, setTableFilter] = useState([]);

  useEffect(async () => {
    const res = await common_axios(
      `admin/v1/fetch/user-status/?userStatus=${Status}`
    );

    setDataSource(res.data.userStatus);
  }, [Status]);

  const filterData = (e) => {
    if (e.target.value != "") {
      setValue(e.target.value);
      const filterTable = dataSource.filter((o) =>
        Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(e.target.value.toLowerCase())
        )
      );

      setTableFilter([...filterTable]);
    } else {
      setValue(e.target.value);
      setDataSource([...dataSource]);
    }
  };

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <div className="container-fluid">
          <h6 className="font-weight-bolder mb-4">User Management</h6>
          <div className="row">
            <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4 mt-4">
              <div className="card mb-3">
                <div className="card-header p-3 pt-2">
                  <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
                    <i className="material-icons opacity-10">person</i>
                  </div>
                  <ul class="nav nav-tabs pt-5" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#AccountDetails"
                        type="button"
                        role="tab"
                        aria-controls="AccountDetails"
                        aria-selected="true"
                      >
                        User
                      </button>
                    </li>

                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="SenderMasking-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#SenderMasking"
                        type="button"
                        role="tab"
                        aria-controls="SenderMasking"
                        aria-selected="false"
                      >
                        User Group
                      </button>
                    </li>
                  </ul>

                  {/* <div className="text_start text-end pt-1">
                    <p className="text-sm mb-0 text-capitalize fw-bold">
                      {" "}
                      Add Circle. Details !! Field(s) marked with{" "}
                      <span className="text-danger fw-bold">*</span> are
                      mandatory.
                    </p>
                  </div> */}
                </div>
                <div className="card-body">
                  <div class="tab-content" id="myTabContent">
                    <div
                      class="tab-pane fade show active"
                      id="AccountDetails"
                      role="tabpanel"
                      aria-labelledby="AccountDetails-tab"
                    >
                      {/* <div class="dropdown">
                        <button
                          class="btn bg-gradient-primary dropdown-toggle m-0"
                          type="button"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Add User
                        </button>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <li>
                            <a
                              class="dropdown-item"
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal_1"
                            >
                              Action
                            </a>
                          </li>
                          <li>
                            <a class="dropdown-item" href="#">
                              Another action
                            </a>
                          </li>
                          <li>
                            <a class="dropdown-item" href="#">
                              Something else here
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div
                        class="modal fade"
                        id="exampleModal_1"
                        tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-dialog-centered">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title" id="exampleModalLabel">
                                Edit User
                              </h5>
                              <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div class="modal-body">
                              <form>
                                <div class="row">
                                  <div class="col-md-3">
                                    <div class="input-group input-group-outline mb-3">
                                      <label class="form-label">
                                        {" "}
                                        First name
                                        <span class="text-danger fw-bold">
                                          *
                                        </span>
                                      </label>
                                      <input type="text" class="form-control" />
                                    </div>
                                  </div>
                                  <div class="col-md-3">
                                    <div class="input-group input-group-outline mb-3">
                                      <label class="form-label">
                                        Last Name
                                        <span class="text-danger fw-bold">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="password"
                                        class="form-control"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-md-3">
                                    <div class="input-group input-group-outline mb-3">
                                      <label class="form-label">
                                        Password policy
                                        <span class="text-danger fw-bold">
                                          *
                                        </span>
                                      </label>
                                      <input type="text" class="form-control" />
                                    </div>
                                  </div>
                                  <div class="col-md-3">
                                    <div class="input-group input-group-outline mb-3">
                                      <label class="form-label">
                                        E-mail
                                        <span class="text-danger fw-bold">
                                          *
                                        </span>
                                      </label>
                                      <input type="text" class="form-control" />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-3">
                                    <div class="input-group input-group-outline">
                                      <select
                                        class="form-control form-select"
                                        id="exampleFormControlSelect2"
                                      >
                                        <option>Access Level</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="col-md-3">
                                    <div class="input-group input-group-outline mb-3">
                                      <label class="form-label">
                                        Connection Type
                                        <span class="text-danger fw-bold">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="password"
                                        class="form-control"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-md-3">
                                    <div class="input-group input-group-outline mb-3">
                                      <label class="form-label">
                                        Department
                                        <span class="text-danger fw-bold">
                                          *
                                        </span>
                                      </label>
                                      <input type="text" class="form-control" />
                                    </div>
                                  </div>
                                  <div class="col-md-3">
                                    <div class="input-group input-group-outline mb-3">
                                      <label class="form-label">
                                        Location
                                        <span class="text-danger fw-bold">
                                          *
                                        </span>
                                      </label>
                                      <input type="text" class="form-control" />
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-primary">
                                Save
                              </button>
                              <button
                                type="button"
                                class="btn btn-secondary"
                                data-bs-dismiss="modal"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="btn bg-gradient-primary m-0 mx-3"
                      >
                        Change Roles
                      </button>
                      <button type="button" class="btn bg-gradient-primary m-0">
                        Delete users
                      </button>
                      <div class="dropdown mx-3">
                        <button
                          class="btn bg-gradient-primary dropdown-toggle m-0"
                          type="button"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          More Actions
                        </button>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <li>
                            <a class="dropdown-item" value="pending">
                              Action
                            </a>
                          </li>
                          <li>
                            <a class="dropdown-item">Another Action</a>
                          </li>
                          <li>
                            <a class="dropdown-item">Something Else Here</a>
                          </li>
                        </ul>
                      </div> */}
                      <div class="dropdown">
                        <button
                          class="btn bg-gradient-primary dropdown-toggle m-0"
                          type="button"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          onChange={(e) => setStatus(e.target.value)}
                        >
                          Status
                        </button>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <li>
                            <a
                              class="dropdown-item"
                              value="pending"
                              onClick={() => {
                                setStatus("allUser");
                              }}
                            >
                              All Users
                            </a>
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              value="pending"
                              onClick={() => {
                                setStatus("pending");
                              }}
                            >
                              Pending
                            </a>
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              value="approved"
                              //   onChange={(e) => setStatus(e.target.value)}
                              onClick={() => {
                                setStatus("approved");
                              }}
                            >
                              Approveds
                            </a>
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              value="rejected"
                              onClick={() => {
                                setStatus("rejected");
                              }}
                            >
                              Rejected
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <input
                    style={{ border: "1px solid black" }}
                    className="form-control inpt ms-auto my-3 p-2"
                    placeholder="Search"
                    onChange={filterData}
                  />
                  <table
                    id="example"
                    className="table table-striped table-bordered table-sm"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th className="text-center p-0 width_1">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="fcustomCheck1"
                            />
                          </div>
                        </th>
                        <th className="text-center width_2">Username Name</th>
                        <th className="text-center">Role</th>
                        <th className="text-center">E-mail id</th>
                        <th className="text-center">user action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {value?.length > 0
                        ? tableFilter?.map((d) => {
                            return (
                              <>
                                <tr>
                                  <td className="text-center">
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value=""
                                        id="fcustomCheck1"
                                      />
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <div className="text-center">
                                      <div className="d-inline-block">
                                        <div className="d-flex align-items-center">
                                          <span className="d-block">
                                            <i className="material-icons opacity-10 size d-block">
                                              info
                                            </i>
                                          </span>
                                          <span className="d-block ms-3">
                                            <i className="material-icons opacity-10 size d-block">
                                              person
                                            </i>
                                          </span>
                                          <span className="d-block me-auto">
                                            {d.username}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    {d.userRoleId}
                                  </td>
                                  <td className="text-center">{d.email}</td>
                                  <td className="text-center">
                                    <div className="dropdown">
                                      <button
                                        className="btn color_1 dropdown-toggle"
                                        type="button"
                                        id="dropdownMenuButton1"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i className="material-icons opacity-10 size">
                                          person
                                        </i>
                                      </button>
                                      <ul
                                        className="dropdown-menu"
                                        aria-labelledby="dropdownMenuButton1"
                                      >
                                        <li>
                                          <a className="dropdown-item" href="#">
                                            Action
                                          </a>
                                        </li>
                                        <li>
                                          <a className="dropdown-item" href="#">
                                            Another action
                                          </a>
                                        </li>
                                        <li>
                                          <a className="dropdown-item" href="#">
                                            Something else here
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            );
                          })
                        : dataSource?.map((d) => {
                            return (
                              <>
                                <tr>
                                  <td className="text-center">
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value=""
                                        id="fcustomCheck1"
                                      />
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <div className="text-center">
                                      <div className="d-inline-block">
                                        <div className="d-flex align-items-center">
                                          <span className="d-block">
                                            <i className="material-icons opacity-10 size d-block">
                                              info
                                            </i>
                                          </span>
                                          <span className="d-block ms-3">
                                            <i className="material-icons opacity-10 size d-block">
                                              person
                                            </i>
                                          </span>
                                          <span className="d-block me-auto">
                                            {d.username}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    {d.userRoleId}
                                  </td>
                                  <td className="text-center">{d.email}</td>
                                  <td className="text-center">
                                    <div className="dropdown">
                                      <button
                                        className="btn color_1 dropdown-toggle"
                                        type="button"
                                        id="dropdownMenuButton1"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i className="material-icons opacity-10 size">
                                          person
                                        </i>
                                      </button>
                                      <ul
                                        className="dropdown-menu"
                                        aria-labelledby="dropdownMenuButton1"
                                      >
                                        <li>
                                          <a className="dropdown-item" href="#">
                                            Action
                                          </a>
                                        </li>
                                        <li>
                                          <a className="dropdown-item" href="#">
                                            Another action
                                          </a>
                                        </li>
                                        <li>
                                          <a className="dropdown-item" href="#">
                                            Something else here
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <input
          style={{ border: "1px solid black" }}
          className="form-control me-2"
          placeholder="Search"
          onChange={filterData}
        /> */}
        {/* <input
          class="form-control me-2"
          type="search"
          placeholder="Search"
          aria-label="Search"
          onChange={filterData}
        /> */}
      </main>
    </>
  );
}
